const Default = { id: 0, font: "'franklin_gothic_bookregular', sans-serif", name: 'Default' };
const Andale = { id: 1, font: "'Andale Mono', monospace", name: 'Andale Mono' };
const Arial = { id: 2, font: "'Arial', sans-serif", name: 'Arial' };
const ArialBlack = { id: 3, font: "'Arial Black', sans-serif", name: 'Arial Black' };
const Baskerville = { id: 4, font: "'Baskerville', serif", name: 'Baskerville' };
const Bradley = { id: 5, font: "'Bradley Hand', cursive", name: 'Bradley Hand' };
const Brush = { id: 6, font: "'Brush Script MT', cursive", name: 'Brush Script MT' };
const Chalkduster = { id: 7, font: "'Chalkduster', fantasy", name: 'Chalkduster' };
const Comic = { id: 8, font: "'Comic Sans MS', cursive", name: 'Comic Sans MS' };
const Courier = { id: 9, font: "'Courier', monospace", name: 'Courier' };
const FiraSans = { id: 10, font: "'Fira-Sans', sans-serif", name: 'FiraSans' };
const Garamond = { id: 11, font: "'Garamond', serif", name: 'Garamond' };
const Georgia = { id: 12, font: "'Georgia', serif", name: 'Georgia' };
const Helvetica = { id: 13, font: "'Helvetica', sans-serif", name: 'Helvetica' };
const HelveticaNeue = { id: 14, font: "'Helvetica Neue', sans-serif", name: 'Helvetica Neue' };
const Impact = { id: 15, font: "'Impact', sans-serif", name: 'Impact' };
const Lato = { id: 16, font: "'Lato', sans-serif", name: 'Lato' };
const Lucida = { id: 17, font: "'Lucida Grande', monospace", name: 'Lucida Grande' };
const Luminari = { id: 18, font: "'Luminari', fantasy", name: 'Luminari' };
const Manrope = { id: 19, font: "'Manrope', sans-serif", name: 'Manrope' };
const MarkerFelt = { id: 20, font: "'Marker Felt', fantasy", name: 'Marker Felt' };
const MetaPro = { id: 21, font: "'Meta-Pro', sans-serif", name: 'MetaPro' };
const MierB = { id: 22, font : "'MierB-Book', 'sans-serif'", name: "MierB" };
const Monaco = { id: 23, font: "'Monaco', monospace", name: 'Monaco' };
const Montserrat = { id: 24, font: "'Montserrat', sans-serif", name: 'Montserrat' };
const OpenSans = { id: 25, font: "'Open Sans', sans-serif", name: 'Open Sans' };
const Palatino = { id: 26, font: "'Palatino', serif", name: 'Palatino' };
const Play = { id: 27, font: "'Play', sans-serif", name: 'Play' };
const Revamped = { id: 28, font: "'Revamped', fantasy", name: 'Revamped'};
const Roboto = { id: 29, font: "'Roboto', sans-serif", name: 'Roboto' };
const SignPainter = { id: 30, font: "'Sign Painter', cursive", name: 'Sign Painter' };
const Stencilla = { id: 31, font: "'Stencilla', fantasy", name: 'Stencilla'}
const Tahoma = { id: 32, font: "'Tahoma', sans-serif", name: 'Tohoma' };
const Times = { id: 33, font: "'Times New Roman', Times, serif", name: 'Times New Roman' };
const TradeGothic = { id: 34, font: "'Trade Gothic', sans-serif", name: 'Trade Gothic' };
const Trajan = { id: 35, font: "'Trajan Pro', serif", name: 'Trajan Pro'};
const Trebuchet = { id: 36, font: "'Trebuchet MS', sans-serif", name: 'Trebuchet MS' };
const Verdana = { id: 37, font: "'Verdana', sans-serif", name: 'Verdana' };

export const fonts = [
    Default,
    Andale,
    Arial,
    ArialBlack,
    Baskerville,
    Bradley,
    Brush,
    Chalkduster,
    Comic,
    Courier,
    FiraSans,
    Garamond,
    Georgia,
    Helvetica,
    HelveticaNeue,
    Impact,
    Lato,
    Lucida,
    Luminari,
    Manrope,
    MarkerFelt,
    MetaPro,
    MierB,
    Monaco,
    Montserrat,
    OpenSans,
    Palatino,
    Play,
    Revamped,
    Roboto,
    SignPainter,
    Stencilla,
    Tahoma,
    Times,
    TradeGothic,
    Trajan,
    Trebuchet,
    Verdana
];